const systemFlag = 'takeaway-merchant';
export default {
  saveObject(key, object) {
    window.localStorage[`${systemFlag}-${key}`] = JSON.stringify(object);
  },
  loadObject(key) {
    try {
      const objectString = window.localStorage[`${systemFlag}-${key}`];
      return objectString == null ? null : JSON.parse(objectString);
    } catch (error) {
      return null
    }
  },
  deleteObject(key) {
    localStorage.removeItem(`${systemFlag}-${key}`);
  },
  clear() {
    window.localStorage.clear();
  }
}
